import { render } from "./DonorClinicalSection.vue?vue&type=template&id=3147a988&scoped=true"
import script from "./DonorClinicalSection.vue?vue&type=script&lang=js"
export * from "./DonorClinicalSection.vue?vue&type=script&lang=js"

import "./DonorClinicalSection.vue?vue&type=style&index=0&id=3147a988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3147a988"],['__file',"src/components/DonorClinicalSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3147a988"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3147a988', __exports__)) {
    api.reload('3147a988', __exports__)
  }
  
  module.hot.accept("./DonorClinicalSection.vue?vue&type=template&id=3147a988&scoped=true", () => {
    api.rerender('3147a988', render)
  })

}


export default __exports__